import {IconWrapperIconProps} from "app/Interface/Component/Icons"
import IconWrapper from "app/WebView/Component/icons/icon"
import React from "react"
import Receipt from "static/icons/receipt_black_24d.svg"

const ModuleInvoiceIcon = (props: IconWrapperIconProps) => {
  const name = "moduleInvoice"
  return (
    <IconWrapper name={name} {...props}>
      <Receipt/>
    </IconWrapper>
  )
}

export default ModuleInvoiceIcon
